import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.kiera.bmc.credentials');
import { OnInit } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';

@Component({
 standalone: false,
 selector: 'wiz-page-kiera-bmc-credentials',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/.kiera-build/src/app/page.kiera.bmc.credentials/view.scss */
:host {
  display: block;
  height: 100%;
  min-height: 100%;
}

button,
input,
select {
  font: inherit;
}

table {
  border-collapse: separate;
  border-spacing: 0;
}

input[type=number] {
  appearance: textfield;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  margin: 0;
}`],
})
export class PageKieraBmcCredentialsComponent implements OnInit {
    public viewMode: string = 'list';
    public wizardStep: number = 1;
    public wizardMode: string = 'create';

    public searchText: string = '';
    public typeFilter: string = 'all';
    public statusFilter: string = 'all';
    public platformFilter: string = 'all';
    public pageSize: number = 10;
    public currentPage: number = 1;
    public sortField: string = 'updated';
    public sortDirection: string = 'desc';
    public selectedIds: number[] = [];
    public selectedCredential: any = null;
    public actionMenuCredential: any = null;
    public settingDefault: boolean = false;
    public actionMenuTop: number = 0;
    public actionMenuLeft: number = 0;
    public isRefreshing: boolean = false;
    public refreshedAt: string = '2026-04-22 14:35';

    public platforms: string[] = [
        'Generic',
        'HPE iLO',
        'Dell iDRAC',
        'Lenovo XClarity',
        'Supermicro',
        'ASUS ASMB',
        'OpenBMC',
        'Other',
    ];

    public protocols: any[] = [
        { value: 'Redfish', label: 'Redfish (HTTPS)', port: 443 },
        { value: 'IPMI', label: 'IPMI', port: 623 },
    ];

    public credentials: any[] = [];

    private readonly credentialStorageKey: string = 'kiera.bmc.credentials';
    private readonly credentialMessageType: string = 'kiera:bmc-credential-saved';

    public form: any = this.emptyForm();
    public formError: string = '';
    public testState: string = 'idle';
    public testMessage: string = '';
    public showPassword: boolean = false;
    public showConfirmPassword: boolean = false;
    public createdCredential: any = null;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.migrateStoredCredentials();
        await this.loadCredentials(false);
        this.selectedCredential = this.credentials[0] || null;
        const params = new URLSearchParams(location.search);
        if (params.get('mode') === 'create') {
            await this.openCreate();
            return;
        }
        await this.service.render();
    }

    private publicCredential(item: any): any {
        const credential = { ...(item || {}) };
        delete credential.password;
        delete credential.confirmPassword;
        return credential;
    }

    private async migrateStoredCredentials() {
        let profiles: any[] = [];
        try {
            const stored = JSON.parse(window.localStorage.getItem(this.credentialStorageKey) || '[]');
            profiles = Array.isArray(stored)
                ? stored.filter((item: any) => item && item.id !== undefined && item.id !== null)
                : [];
        } catch (error) {
            profiles = [];
        }
        if (profiles.length === 0) return;
        const { code } = await wiz.call('migrate_local', { profiles: JSON.stringify(profiles) });
        if (code === 200) {
            try {
                window.localStorage.removeItem(this.credentialStorageKey);
            } catch (error) {
                // 서버 이전이 끝났으므로 브라우저 저장소 정리 실패는 동작에 영향을 주지 않는다.
            }
        }
    }

    private async loadCredentials(render: boolean = true) {
        const selectedId = this.selectedCredential?.id;
        const { code, data } = await wiz.call('list');
        if (code === 200) {
            this.credentials = Array.isArray(data?.rows) ? data.rows : [];
            this.selectedCredential = this.credentials.find((item: any) =>
                String(item.id) === String(selectedId)
            ) || this.credentials[0] || null;
        }
        if (render) await this.service.render();
    }

    private notifyCredentialSaved(item: any) {
        if (!window.opener || window.opener.closed) return;
        window.opener.postMessage({
            type: this.credentialMessageType,
            credential: this.publicCredential(item),
        }, window.location.origin);
    }

    public emptyForm() {
        return {
            id: null,
            name: '',
            description: '',
            platform: 'Generic',
            protocol: 'Redfish',
            port: 443,
            tls: true,
            username: '',
            password: '',
            confirmPassword: '',
            managementIp: '',
            timeout: 30,
            retries: 3,
            active: true,
            is_default: false,
        };
    }

    public filteredCredentials(): any[] {
        const term = this.searchText.trim().toLowerCase();
        const rows = this.credentials.filter((item: any) => {
            const matchesText = !term || [
                item.name,
                item.description,
                item.platform,
                item.protocol,
                item.username,
            ].some((value: any) => String(value || '').toLowerCase().indexOf(term) >= 0);
            const matchesType = this.typeFilter === 'all' || item.protocol === this.typeFilter;
            const matchesStatus = this.statusFilter === 'all'
                || (this.statusFilter === 'active' && item.active)
                || (this.statusFilter === 'inactive' && !item.active);
            const matchesPlatform = this.platformFilter === 'all' || item.platform === this.platformFilter;
            return matchesText && matchesType && matchesStatus && matchesPlatform;
        });

        return rows.sort((a: any, b: any) => {
            let left: any = a[this.sortField];
            let right: any = b[this.sortField];
            if (typeof left === 'boolean') left = left ? 1 : 0;
            if (typeof right === 'boolean') right = right ? 1 : 0;
            if (typeof left === 'number' && typeof right === 'number') {
                return (left - right) * (this.sortDirection === 'asc' ? 1 : -1);
            }
            return String(left || '').localeCompare(String(right || ''))
                * (this.sortDirection === 'asc' ? 1 : -1);
        });
    }

    public pagedCredentials(): any[] {
        const start = (this.currentPage - 1) * this.pageSize;
        return this.filteredCredentials().slice(start, start + this.pageSize);
    }

    public totalPages(): number {
        return Math.max(1, Math.ceil(this.filteredCredentials().length / this.pageSize));
    }

    public pageNumbers(): number[] {
        const pages: number[] = [];
        for (let page = 1; page <= this.totalPages(); page++) pages.push(page);
        return pages;
    }

    public visibleFrom(): number {
        if (this.filteredCredentials().length === 0) return 0;
        return (this.currentPage - 1) * this.pageSize + 1;
    }

    public visibleTo(): number {
        return Math.min(this.currentPage * this.pageSize, this.filteredCredentials().length);
    }

    public activeCount(): number {
        return this.credentials.filter((item: any) => item.active).length;
    }

    public inactiveCount(): number {
        return this.credentials.filter((item: any) => !item.active).length;
    }

    public platformCount(): number {
        return Array.from(new Set(this.credentials.map((item: any) => item.platform))).length;
    }

    public latestUpdated(): any {
        const rows = this.credentials.slice().sort((a: any, b: any) =>
            String(b.updated || '').localeCompare(String(a.updated || ''))
        );
        return rows[0] || null;
    }

    public datePart(value: string): string {
        if (!value || value === '-') return '-';
        return String(value).split(' ')[0];
    }

    public timePart(value: string): string {
        if (!value || value === '-' || String(value).indexOf(' ') < 0) return '';
        return String(value).split(' ')[1];
    }

    public protocolLabel(protocol: string): string {
        return protocol === 'Redfish' ? 'Redfish (HTTPS)' : 'IPMI';
    }

    public platformBadgeClass(platform: string): string {
        const classes: any = {
            'HPE iLO': 'bg-blue-50 text-blue-700 border-blue-100',
            'Dell iDRAC': 'bg-sky-50 text-sky-700 border-sky-100',
            'Lenovo XClarity': 'bg-orange-50 text-orange-700 border-orange-100',
            'Supermicro': 'bg-violet-50 text-violet-700 border-violet-100',
            'ASUS ASMB': 'bg-rose-50 text-rose-700 border-rose-100',
            'OpenBMC': 'bg-emerald-50 text-emerald-700 border-emerald-100',
            'Other': 'bg-slate-100 text-slate-700 border-slate-200',
        };
        return classes[platform] || 'bg-zinc-100 text-zinc-700 border-zinc-200';
    }

    public async applyFilters() {
        this.currentPage = 1;
        await this.service.render();
    }

    public async resetFilters() {
        this.searchText = '';
        this.typeFilter = 'all';
        this.statusFilter = 'all';
        this.platformFilter = 'all';
        this.currentPage = 1;
        await this.service.render();
    }

    public async refreshList() {
        this.isRefreshing = true;
        await this.service.render();
        await this.loadCredentials(false);
        this.refreshedAt = this.nowText();
        this.isRefreshing = false;
        await this.service.render();
    }

    public async sort(field: string) {
        if (this.sortField === field) {
            this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
        } else {
            this.sortField = field;
            this.sortDirection = 'asc';
        }
        await this.service.render();
    }

    public sortIcon(field: string): string {
        if (this.sortField !== field) return 'bx-sort-alt-2';
        return this.sortDirection === 'asc' ? 'bx-sort-up' : 'bx-sort-down';
    }

    public async toggleActionMenu(item: any, event: Event) {
        event.stopPropagation();
        if (this.actionMenuCredential?.id === item.id) {
            this.actionMenuCredential = null;
            await this.service.render();
            return;
        }

        const trigger = event.currentTarget as HTMLElement;
        const rect = trigger.getBoundingClientRect();
        const menuWidth = 144;
        const menuHeight = 152;
        const gap = 4;
        this.actionMenuLeft = Math.max(
            8,
            Math.min(window.innerWidth - menuWidth - 8, rect.right - menuWidth)
        );
        this.actionMenuTop = rect.bottom + menuHeight + gap <= window.innerHeight - 8
            ? rect.bottom + gap
            : Math.max(8, rect.top - menuHeight - gap);
        this.selectedCredential = item;
        this.actionMenuCredential = item;
        await this.service.render();
    }

    public async closeActionMenu() {
        if (!this.actionMenuCredential) return;
        this.actionMenuCredential = null;
        await this.service.render();
    }

    public async runCredentialAction(action: string, event: Event) {
        event.stopPropagation();
        const credential = this.actionMenuCredential;
        this.actionMenuCredential = null;
        if (!credential) return;

        if (action === 'default') {
            await this.setDefaultCredential(credential);
            return;
        }
        if (action === 'edit') {
            await this.editCredential(credential);
            return;
        }
        if (action === 'duplicate') {
            await this.duplicateCredential(credential);
            return;
        }
        if (action === 'delete') {
            await this.deleteCredential(credential);
        }
    }

    public isSelected(id: number): boolean {
        return this.selectedIds.indexOf(id) >= 0;
    }

    public async toggleSelected(id: number, event?: Event) {
        if (event) event.stopPropagation();
        this.actionMenuCredential = null;
        if (this.isSelected(id)) {
            this.selectedIds = this.selectedIds.filter((value: number) => value !== id);
        } else {
            this.selectedIds = this.selectedIds.concat([id]);
        }
        await this.service.render();
    }

    public allPageSelected(): boolean {
        const rows = this.pagedCredentials();
        return rows.length > 0 && rows.every((item: any) => this.isSelected(item.id));
    }

    public async toggleAllPage() {
        this.actionMenuCredential = null;
        const ids = this.pagedCredentials().map((item: any) => item.id);
        if (this.allPageSelected()) {
            this.selectedIds = this.selectedIds.filter((id: number) => ids.indexOf(id) < 0);
        } else {
            this.selectedIds = Array.from(new Set(this.selectedIds.concat(ids)));
        }
        await this.service.render();
    }

    public async clearSelection(event?: Event) {
        if (event) event.stopPropagation();
        this.selectedIds = [];
        await this.service.render();
    }

    public async deleteSelectedCredentials(event?: Event) {
        if (event) event.stopPropagation();
        const selectedCredentials = this.credentials.filter((item: any) =>
            this.selectedIds.indexOf(item.id) >= 0
        );
        if (selectedCredentials.length === 0) return;

        const protectedCredentials = selectedCredentials.filter((item: any) =>
            Number(item.clusters || 0) > 0
        );
        const deletableCredentials = selectedCredentials.filter((item: any) =>
            Number(item.clusters || 0) <= 0
        );

        if (deletableCredentials.length === 0) {
            await this.service.modal.show({
                title: '삭제할 수 없습니다',
                message: '선택한 Credential이 모두 클러스터에서 사용 중입니다. 할당을 해제한 뒤 삭제하세요.',
                action: '확인',
                cancel: false,
                status: 'warning',
                actionBtn: 'warning',
            });
            return;
        }

        const message = protectedCredentials.length > 0
            ? '선택한 ' + selectedCredentials.length + '개 중 사용 중인 '
                + protectedCredentials.length + '개를 제외한 '
                + deletableCredentials.length + '개를 삭제하시겠습니까?'
            : '선택한 Credential ' + deletableCredentials.length + '개를 모두 삭제하시겠습니까?';
        const confirmed = await this.service.modal.show({
            title: '선택 Credential 전체 삭제',
            message,
            action: '삭제',
            cancel: '취소',
            status: 'error',
            actionBtn: 'error',
        });
        if (!confirmed) return;

        const deleteIds = deletableCredentials.map((item: any) => item.id);
        const { code, data } = await wiz.call('delete', { ids: JSON.stringify(deleteIds) });
        if (code !== 200) {
            await this.service.modal.show({
                title: '삭제할 수 없습니다',
                message: data?.message || 'Credential 삭제에 실패했습니다.',
                action: '확인',
                cancel: false,
                status: 'warning',
                actionBtn: 'warning',
            });
            return;
        }
        this.selectedIds = protectedCredentials.map((item: any) => item.id);
        this.actionMenuCredential = null;
        await this.loadCredentials(false);
        await this.service.render();
    }

    public async selectCredential(item: any) {
        this.selectedCredential = item;
        this.actionMenuCredential = null;
        await this.service.render();
    }

    public async goPage(page: number) {
        if (page < 1 || page > this.totalPages()) return;
        this.currentPage = page;
        await this.service.render();
    }

    public async openCreate() {
        this.actionMenuCredential = null;
        this.wizardMode = 'create';
        this.wizardStep = 1;
        this.form = this.emptyForm();
        this.formError = '';
        this.testState = 'idle';
        this.testMessage = '';
        this.createdCredential = null;
        this.viewMode = 'wizard';
        await this.service.render();
    }

    public async editCredential(item: any) {
        this.wizardMode = 'edit';
        this.wizardStep = 1;
        this.form = {
            id: item.id,
            name: item.name,
            description: item.description,
            platform: item.platform,
            protocol: item.protocol,
            port: item.port,
            tls: item.tls,
            username: item.username,
            password: '',
            confirmPassword: '',
            managementIp: item.host === '-' ? '' : item.host,
            timeout: item.timeout,
            retries: item.retries,
            active: item.active,
            is_default: !!item.is_default,
        };
        this.formError = '';
        this.testState = 'idle';
        this.testMessage = '';
        this.createdCredential = null;
        this.viewMode = 'wizard';
        await this.service.render();
    }

    public async duplicateCredential(item: any) {
        this.wizardMode = 'create';
        this.wizardStep = 1;
        this.form = {
            id: null,
            name: item.name + '_Copy',
            description: item.description,
            platform: item.platform,
            protocol: item.protocol,
            port: item.port,
            tls: item.tls,
            username: item.username,
            password: '',
            confirmPassword: '',
            managementIp: '',
            timeout: item.timeout,
            retries: item.retries,
            active: item.active,
        };
        this.formError = '';
        this.testState = 'idle';
        this.testMessage = '';
        this.createdCredential = null;
        this.viewMode = 'wizard';
        await this.service.render();
    }

    public async setDefaultCredential(item: any) {
        if (!item || item.is_default || !item.active || this.settingDefault) return;
        this.settingDefault = true;
        this.actionMenuCredential = null;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('save', {
                data: JSON.stringify({ id: item.id, is_default: true }),
            });
            if (code !== 200 || !data?.credential) {
                throw new Error(data?.message || '기본 BMC Credential 설정에 실패했습니다.');
            }
            await this.loadCredentials(false);
            this.notifyCredentialSaved(data.credential);
        } catch (error: any) {
            await this.service.modal.show({
                title: '기본값 설정 실패',
                message: error?.message || '기본 BMC Credential 설정에 실패했습니다.',
                action: '확인',
                cancel: false,
                status: 'warning',
                actionBtn: 'warning',
            });
        } finally {
            this.settingDefault = false;
            await this.service.render();
        }
    }

    public async deleteCredential(item: any) {
        this.actionMenuCredential = null;
        if (Number(item.clusters || 0) > 0) {
            await this.service.modal.show({
                title: '삭제할 수 없습니다',
                message: '이 Credential은 ' + Number(item.clusters || 0) + '개 클러스터에서 사용 중입니다. 할당을 해제한 뒤 삭제하세요.',
                action: '확인',
                cancel: false,
                status: 'warning',
                actionBtn: 'warning',
            });
            return;
        }

        const confirmed = await this.service.modal.show({
            title: 'BMC Credential 삭제',
            message: item.name + ' 프로필을 삭제하시겠습니까?',
            action: '삭제',
            cancel: '취소',
            status: 'error',
            actionBtn: 'error',
        });
        if (!confirmed) return;

        const { code, data } = await wiz.call('delete', { ids: JSON.stringify([item.id]) });
        if (code !== 200) {
            await this.service.modal.show({
                title: '삭제할 수 없습니다',
                message: data?.message || 'Credential 삭제에 실패했습니다.',
                action: '확인',
                cancel: false,
                status: 'warning',
                actionBtn: 'warning',
            });
            return;
        }
        this.selectedIds = this.selectedIds.filter((id: number) => id !== item.id);
        await this.loadCredentials(false);
        await this.service.render();
    }

    public async onProtocolChange() {
        const option = this.protocols.find((item: any) => item.value === this.form.protocol);
        if (option) this.form.port = option.port;
        this.form.tls = this.form.protocol === 'Redfish';
        this.testState = 'idle';
        this.testMessage = '';
        await this.service.render();
    }

    public validateForm(): string {
        const name = String(this.form.name || '').trim();
        if (!/^[A-Za-z0-9_.-]{2,50}$/.test(name)) {
            return 'Profile Name은 2~50자의 영문, 숫자, _, -, .만 사용할 수 있습니다.';
        }
        const duplicate = this.credentials.some((item: any) =>
            item.id !== this.form.id && String(item.name).toLowerCase() === name.toLowerCase()
        );
        if (duplicate) return '이미 사용 중인 Profile Name입니다.';
        if (!this.form.platform) return 'Platform을 선택하세요.';
        if (!this.form.protocol) return 'Protocol을 선택하세요.';
        const port = Number(this.form.port);
        if (!port || port < 1 || port > 65535) return 'Port는 1~65535 범위로 입력하세요.';
        if (!String(this.form.username || '').trim()) return 'Username을 입력하세요.';
        const existing = this.credentials.find((item: any) => item.id === this.form.id);
        if (!this.form.password && !existing?.hasPassword) return 'Password를 입력하세요.';
        if (this.form.password && this.form.password !== this.form.confirmPassword) {
            return 'Password와 Confirm Password가 일치하지 않습니다.';
        }
        return '';
    }

    public async goReview() {
        this.formError = this.validateForm();
        if (this.formError) {
            await this.service.render();
            return;
        }
        this.wizardStep = 2;
        await this.service.render();
    }

    public async backToForm() {
        this.wizardStep = 1;
        await this.service.render();
    }

    public async testConnection() {
        if (!String(this.form.managementIp || '').trim()) {
            this.testState = 'error';
            this.testMessage = '테스트할 Management IP를 입력하세요.';
            await this.service.render();
            return;
        }
        const existing = this.credentials.find((item: any) => item.id === this.form.id);
        if (!String(this.form.username || '').trim() || (!this.form.password && !existing?.hasPassword)) {
            this.testState = 'error';
            this.testMessage = 'Username과 Password를 먼저 입력하세요.';
            await this.service.render();
            return;
        }

        this.testState = 'testing';
        this.testMessage = 'BMC 장비에 연결하고 있습니다.';
        await this.service.render();
        const payload = {
            id: this.form.id,
            host: String(this.form.managementIp || '').trim(),
            protocol: this.form.protocol,
            port: Number(this.form.port),
            tls: !!this.form.tls,
            username: String(this.form.username || '').trim(),
            password: String(this.form.password || ''),
            timeout: Number(this.form.timeout) || 30,
        };
        const { code, data } = await wiz.call('test_connection', { data: JSON.stringify(payload) });
        const result = data?.result || {};
        this.testState = code === 200 && result.ok ? 'success' : 'error';
        this.testMessage = this.testState === 'success'
            ? 'BMC 연결 테스트에 성공했습니다.'
            : (data?.message || result.message || 'BMC 연결 테스트에 실패했습니다.');
        await this.service.render();
    }

    public async saveCredential() {
        this.formError = this.validateForm();
        if (this.formError) {
            this.wizardStep = 1;
            await this.service.render();
            return;
        }

        const now = this.nowText();
        const payload: any = {
            id: this.form.id,
            name: String(this.form.name).trim(),
            description: String(this.form.description || '').trim(),
            platform: this.form.platform,
            protocol: this.form.protocol,
            username: String(this.form.username).trim(),
            active: !!this.form.active,
            is_default: !!this.form.is_default,
            host: String(this.form.managementIp || '').trim(),
            port: Number(this.form.port),
            tls: !!this.form.tls,
            timeout: Number(this.form.timeout) || 30,
            retries: Number(this.form.retries) || 3,
        };
        if (this.form.password) payload.password = String(this.form.password);
        if (this.testState === 'success') {
            payload.lastTest = now;
            payload.testStatus = 'success';
        }
        const { code, data } = await wiz.call('save', { data: JSON.stringify(payload) });
        if (code !== 200 || !data?.credential) {
            this.formError = data?.message || 'Credential 저장에 실패했습니다.';
            this.wizardStep = 1;
            await this.service.render();
            return;
        }
        const saved = data.credential;
        await this.loadCredentials(false);
        this.createdCredential = { ...saved };
        this.selectedCredential = saved;
        this.notifyCredentialSaved(saved);
        this.wizardStep = 3;
        await this.service.render();
    }

    public async cancelWizard() {
        this.viewMode = 'list';
        this.wizardStep = 1;
        this.formError = '';
        await this.service.render();
    }

    public async newAfterSuccess() {
        await this.openCreate();
    }

    public async goDashboard() {
        this.service.href('/kiera');
    }

    public passwordSummary(): string {
        if (this.form.password) return '••••••••••••';
        return this.wizardMode === 'edit' ? '변경 없음' : '••••••••';
    }

    public nowText(): string {
        const now = new Date();
        const pad = (value: number) => String(value).padStart(2, '0');
        return now.getFullYear() + '-' + pad(now.getMonth() + 1) + '-' + pad(now.getDate())
            + ' ' + pad(now.getHours()) + ':' + pad(now.getMinutes());
    }

    public trackByCredential(index: number, item: any) {
        return item.id;
    }
}

export default PageKieraBmcCredentialsComponent;
